import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import uploadImageDefault from "../../images/upload-image.jpg";
import notify from '../UseNotification'
import { editCategory, getOneCategory } from '../../redux/Slices/CategorySlice';

const UseAdminEditCategory = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState()
    const [SubmitLoading, setSubmitLoading] = useState()
    const [isPress, setIsPress] = useState(false)
    const [ImageSrc, setImageSrc] = useState(uploadImageDefault)
    const [CategoryName, setCategoryName] = useState("")
    const [SelectedImage, setSelectedImage] = useState("")
    const [isFormValid, setIsFormValid] = useState(false)
    const [isImageChanged, setIsImageChanged] = useState(false);
    const { OneCategory, editOneCategory } = useSelector(state => state.CategoryReducer)

    // to get category data
    const getCategoryData = async () => {
        setLoading(true)
        await dispatch(getOneCategory(id))
        setLoading(false)
    }

    // to run get category data
    useEffect(() => {
        getCategoryData()
    }, [])


    // to handle request response to get category details
    useEffect(() => {
        if (loading === false) {
            if (OneCategory && OneCategory.data) {
                setImageSrc(OneCategory.data.data.image)
                setCategoryName(OneCategory.data.data.name)
            }
        }
    }, [loading])

    // to change category image
    const OnChangeCategoryImage = (e) => {
        if (e.target.files && e.target.files[0]) {
            setImageSrc(URL.createObjectURL(e.target.files[0]));
            setSelectedImage(e.target.files[0]);
            setIsImageChanged(true);
            setIsFormValid(true)
        } else {
            setIsImageChanged(false);
            setIsFormValid(false);
            setSelectedImage(OneCategory.data.data.image);
        }
    }


    // to change category name
    const OnChangeCategoryName = (e) => {
        setCategoryName(e.target.value)
        if (e.target.value.length >= 3) {
            setIsFormValid(true)
        }
        else {
            setIsFormValid(false)
        }
    }

    // vaidate category name
    const ValidateCategoryName = (e) => {
        if (e.target.value === "") {
            notify("Category name must at least 3 character", "error")
        }
    }


    // submit form
    const SubmitForm = async (e) => {
        e.preventDefault();
        setIsPress(true);
        if (CategoryName?.length < 3) {
            notify("Category Name must be at least 3 chars", "error");
            return;
        }

        const formData = new FormData();
        let imageUrl = OneCategory.data.data.image;
        if (imageUrl.startsWith('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/')) {
            imageUrl = imageUrl.replace('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/', '');
        }
        else if (imageUrl.startsWith('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/')) {
            imageUrl = imageUrl.replace('http://127.0.0.1:8000/categories/', '');
        }
        else if (imageUrl.startsWith('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/')) {
            imageUrl = imageUrl.replace('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/', '');
        }
        else {
            imageUrl = OneCategory.data.data.image
        }
        if (isImageChanged) {
            formData.append("image", SelectedImage);
        } else if (!isImageChanged) {

            formData.append("image", imageUrl);
        }
        formData.append("name", CategoryName);

        setSubmitLoading(true);
        await dispatch(editCategory({ id, formData }));
        setSubmitLoading(false);
    }

    // to handle the response edit request
    useEffect(() => {
        if (SubmitLoading === false) {
            setIsPress(false)
            if (editOneCategory && editOneCategory.response) {
                if (editOneCategory && editOneCategory.response.status === 500) {
                    notify("Please complete the data", "error")
                } else if (editOneCategory && editOneCategory.response.status === 401) {
                    notify("Please login to can add new Category", "error")
                }
            } else if (editOneCategory && editOneCategory.status === 200) {
                notify("Category Edit", "success");
            }
        }
    }, [SubmitLoading])


    return [ValidateCategoryName, isFormValid, ImageSrc, CategoryName, OnChangeCategoryImage, OnChangeCategoryName, isPress, SubmitLoading, SubmitForm]
}

export default UseAdminEditCategory
